var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingWhiteboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "316D66A2-E9AA-4A5E-858B-252BBCCCC156") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Supply-Analytics-Overview---GMSupply",
    transform: "translate(-731.000000, -99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ranking",
    transform: "translate(562.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ranking-icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cross-icon",
    transform: "translate(0.000000, 6.602715)",
    stroke: "#404040",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.602714896,
    y1: 1.78439455e-16,
    x2: 0.602714896,
    y2: 1.20542979,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.57697201e-14,
    y1: 0.602714896,
    x2: 1.20542979,
    y2: 0.602714896,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 0.602714896,
    cy: 0.602714896,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cross-Icon",
    transform: "translate(10.675112, 0.000000)",
    stroke: "#404040",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.602714896,
    y1: 1.78439455e-16,
    x2: 0.602714896,
    y2: 1.20542979,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.57697201e-14,
    y1: 0.602714896,
    x2: 1.20542979,
    y2: 0.602714896,
    id: "Line",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 0.602714896,
    cy: 0.602714896,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Board",
    transform: "translate(2.307692, 0.692308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.23076923,7.70769231 C9.400703,7.70769231 9.53846154,7.84545085 9.53846154,8.01538462 L9.53846154,8.6 C9.53846154,8.76993377 9.400703,8.90769231 9.23076923,8.90769231 L6.654,8.90769231 L7.50423063,10.381262 C7.57705939,10.5074051 7.55041793,10.6636815 7.44864322,10.7592644 L7.39160743,10.8015775 L6.88531565,11.0938852 C6.73814869,11.1788521 6.54996703,11.128429 6.46500014,10.981262 L6.46500014,10.981262 L5.268,8.90769231 L4.47,8.90769231 L3.2734614,10.981262 C3.18849451,11.128429 3.00031285,11.1788521 2.85314589,11.0938852 L2.34685411,10.8015775 C2.19968715,10.7166107 2.14926403,10.528429 2.23423091,10.381262 L3.084,8.90769231 L0.307692308,8.90769231 C0.137758539,8.90769231 4.31512413e-15,8.76993377 4.4408921e-15,8.6 L4.4408921e-15,8.01538462 C4.30905891e-15,7.84545085 0.137758539,7.70769231 0.307692308,7.70769231 L9.23076923,7.70769231 Z",
    id: "Rectangle-2",
    stroke: "#404040",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#404040",
    strokeWidth: 0.6,
    x: 5.68434189e-14,
    y: 7.70769231,
    width: 9.53846154,
    height: 1.2,
    rx: 0.307692308
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#404040",
    strokeWidth: 0.6,
    x: 0.615384615,
    y: 2.84615385,
    width: 8.30769231,
    height: 4.92307692
  }), /*#__PURE__*/React.createElement("g", {
    id: "charts",
    transform: "translate(1.923077, 4.076923)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#404040",
    x: 4.07692308,
    y: 1.23076923,
    width: 1,
    height: 1.07692308,
    rx: 0.153846154
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#404040",
    x: 4.96923077,
    y: -2.19824159e-14,
    width: 1,
    height: 2.30769231,
    rx: 0.153846154
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-2",
    stroke: "#404040",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "-6.66133815e-15 1.92307692 0.777786078 1.03647105 1.84553497 1.67963762 2.69230769 0.615384615"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#404040",
    strokeWidth: 0.6,
    x: 4.17230769,
    y: 0.707692308,
    width: 1.1925,
    height: 1.8,
    rx: 0.307692308
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#404040",
    strokeWidth: 0.6,
    fill: "#FFFFFF",
    x: 5.68434189e-14,
    y: 1.70769231,
    width: 9.53846154,
    height: 1.2,
    rx: 0.307692308
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingWhiteboard);
export default __webpack_public_path__ + "static/media/ranking-whiteboard.2d9fc8dd4823aea7e0b949408632ca04.svg";
export { ForwardRef as ReactComponent };